import { getInitials } from 'shared/utils/get_initials'

export const CRM_NEEDS_ATTENTION_FLAG_KEY = 'crm_needs_attention_feature'

const GMAIL_EMAIL_DOMAINS = new Set(['gmail.com', 'googlemail.com'])

export const getCrmContactId = (contact = {}) => (
  contact?.uuid || contact?.id || null
)

export const isTypedNonContactRecipient = (contact = {}) => (
  Boolean(contact?.email?.trim()) && !getCrmContactId(contact)
)

export const isGmailEmailAddress = (email = '') => {
  const normalizedEmail = email.trim().toLowerCase()
  const atIndex = normalizedEmail.lastIndexOf('@')

  if (atIndex === -1) {
    return false
  }

  return GMAIL_EMAIL_DOMAINS.has(normalizedEmail.slice(atIndex + 1))
}

export const isGmailSyncedContact = (contact = {}) => (
  contact?.sourceDisplayCategory === 'google_calendar'
)

export const getNonContactRecipientLabel = (contact = {}) => contact?.email?.trim() || ''

export const getNonContactRecipientInitial = (email = '') => {
  const trimmedEmail = email.trim()
  if (!trimmedEmail) return ''

  const atIndex = trimmedEmail.indexOf('@')
  const localPart = (atIndex === -1 ? trimmedEmail : trimmedEmail.slice(0, atIndex)).trim()

  return localPart ? getInitials(localPart) : ''
}

export const shouldUseBlankAvatarForNonContact = (contact = {}) => (
  isTypedNonContactRecipient(contact)
)

export const shouldShowGmailBrandmarkForNonContact = (contact = {}) => (
  isTypedNonContactRecipient(contact) && isGmailEmailAddress(contact?.email)
)

export const isGmailRecipientWithBrandmark = (contact = {}) => (
  shouldShowGmailBrandmarkForNonContact(contact)
  || (isGmailSyncedContact(contact) && !isTypedNonContactRecipient(contact))
)
